import React, { Component } from "react";
import client from "@culturehq/client";
import { ActionButton, Button, Info, Panel, Table, Warning } from "@culturehq/components";

import { Trans } from "app/utils";

import ChqModalConfirmDelete from "components/common/ChqModalConfirmDelete";
import ExpenseModal from "./ExpenseModal";
import styles from "./expenses.module.scss";

const ExpenseRow = ({ event, expense, onUpdate, onDelete }) => (
  <tr>
    <td>{expense.display}</td>
    <td>{expense.description}</td>
    <td>
      <ExpenseModal expense={expense} event={event} onUpdate={onUpdate}>
        {onTrigger => (
          <ActionButton icon="edit" onClick={onTrigger}>
            <Trans>Edit</Trans>
          </ActionButton>
        )}
      </ExpenseModal>
      <ChqModalConfirmDelete
        onAccept={() => onDelete(expense)}
        trigger={onTrigger => (
          <ActionButton icon="trash-a" onClick={onTrigger}>
            <Trans>Delete</Trans>
          </ActionButton>
        )}
      >
        <Trans>Are you sure you want to delete this expense?</Trans>
      </ChqModalConfirmDelete>
    </td>
  </tr>
);

const ExpenseTable = ({ event, expenses, onUpdate, onDelete }) => (
  <Table>
    <thead>
      <tr>
        <th><Trans>Amount</Trans></th>
        <th><Trans>Description</Trans></th>
        <th>
          <span className="pull-right">
            <Trans>Actions</Trans>
          </span>
        </th>
      </tr>
    </thead>
    <tbody>
      {expenses.map(expense => (
        <ExpenseRow
          key={expense.id}
          event={event}
          expense={expense}
          onUpdate={onUpdate}
          onDelete={onDelete}
        />
      ))}
    </tbody>
  </Table>
);

const ExpenseSum = ({ sum }) => {
  const dollars = Math.floor(sum / 100);
  const cents = `0${sum % 100}`.slice(-2);

  return (
    <span className={styles.sum}>
      <Trans>Total: </Trans> ${dollars}.{cents}
    </span>
  );
};

class Expenses extends Component {
  state = { expenses: [], sum: 0 };

  componentDidMount() {
    this.fetchExpenses();
  }

  fetchExpenses = async () => {
    const { event: { id: eventId } } = this.props;

    const { expenses } = await client.listExpenses({ eventId });
    const sum = expenses.reduce((accum, { amount }) => accum + amount, 0);

    this.setState({ expenses, sum });
  };

  handleDelete = async ({ id: expenseId, amount }) => {
    const { event: { id: eventId } } = this.props;

    await client.deleteExpense({ eventId, expenseId });

    this.setState(({ expenses, sum }) => ({
      expenses: expenses.filter(expense => expense.id !== expenseId),
      sum: sum - amount
    }));
  };

  render() {
    const { event } = this.props;
    const { expenses, sum } = this.state;

    return (
      <div className="panel panel-default box-shadow">
        {event.cancelledAt && (
          <Warning>
            <Trans>This event has been cancelled.</Trans>
          </Warning>
        )}

        {event.isPast() && !event.cancelledAt && (
          <Info>
            <Trans>This event has ended.</Trans>
          </Info>
        )}
        <Panel>
          <Panel.Heading primary>
            <Trans>Expenses</Trans>
          </Panel.Heading>
          <Panel.Body>
            <p className="clearfix">
              <ExpenseModal event={event} onUpdate={this.fetchExpenses}>
                {onTrigger => (
                  <Button className="pull-left" icon="plus" inverted onClick={onTrigger}>
                    <Trans>Add New Expense</Trans>
                  </Button>
                )}
              </ExpenseModal>

              {sum > 0 && <ExpenseSum sum={sum} />}
            </p>

            <ExpenseTable
              event={event}
              expenses={expenses}
              onUpdate={this.fetchExpenses}
              onDelete={this.handleDelete}
            />

            {expenses && expenses.length < 1 && (
              <p className="empty"><Trans>No expenses to show.</Trans></p>
            )}
          </Panel.Body>
        </Panel>
      </div>
    );
  }
}

export default Expenses;
